<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
    <el-form ref="form" label-position="left" :model="form" label-width="120px">
      <el-form-item label="所属仓库" required>
        <el-select v-model="form.warehouse" placeholder="" style="width: 100%" :disabled="true">
          <el-option :label="item.wareName" :value="item.wareCode" v-for="item in warehouseList" :key="item.wareCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货类型" required>
        <el-radio-group v-model="form.deliverType">
          <el-radio :label="0" v-if="type == 'B2B'">FBA发货</el-radio>
          <el-radio :label="1" v-if="type == 'B2B'">大件普通发货</el-radio>
          <el-radio :label="2" v-if="type == 'D2C'">小件普通发货</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="货代公司" required>
        <el-select v-model="form.logisticsCompanyCode" placeholder="请选择活动区域" style="width: 100%">
          <el-option label="OCS" value="OCS"> </el-option>
          <el-option label="杭州义达" value="YD"> </el-option>
          <el-option label="杭州思凯比" value="SKB"> </el-option>
          <el-option label="广州天汇" value="TH"> </el-option>
          <!-- <el-option
            :label="item.forwarder"
            :value="item.logisticsCompanyCode"
            v-for="item in forwarder"
            :key="item.logisticsCompanyCode"
          ></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="新增类型" required>
        <el-radio-group v-model="form.boxType">
          <el-radio :label="1" :value="1" v-if="type == 'B2B'">容器</el-radio>
          <el-radio :label="2" :value="2" v-if="type == 'B2B'">箱子</el-radio>
          <el-radio :label="3" :value="3" v-if="type == 'D2C'">包裹</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="重量上限" required>
        <el-input maxlength='450' v-model="form.weightLimit"></el-input>
        <div style="text-align: left">若无上限，请输入"-1"</div>
      </el-form-item>
      <el-form-item label="美金上限" required>
        <el-input maxlength='450' v-model="form.priceLimit"></el-input>
        <div style="text-align: left">若无上限，请输入"-1"</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确认</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { addConfig, editConfig } from "@/apis/configure";
import { Validator } from "@/utils/verification";
export default {
  name: "SetFree",
  data() {
    return {
      dialogVisible: false,
      form: {
        warehouse: this.$store.getters.getWareCode,
        shipStatus: "",
        company: "",
        newType: "",
        weight: "",
        money: "",
      },
    };
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    warehouseList: {
      type: Array,
      required: true,
    },
    forwarder: {
      type: Array,
      required: true,
    },
  },
  methods: {
    open: function (r) {
      if (r) {
        this.form = r;
        this.form.warehouse = this.$store.getters.getWareCode;
      }
      this.dialogVisible = true;
    },
    close: function () {
      this.dialogVisible = false;
      this.form = {
        warehouse: this.$store.getters.getWareCode,
      };
    },
    onSubmit: function () {
      let params = {
        ...this.form,
        systemSource: this.type == "B2B" ? 2 : 1,
      };
      let validator = new Validator();
      validator.loopAdd(
        [
          params.deliverType,
          // params.intForwarderConfigId,
          params.logisticsCompanyCode,
          params.boxType,
          params.priceLimit,
          params.weightLimit,
        ],
        "isNoneEmpty",
        "请填写数据"
      );
      let error = validator.start();
      if (error) {
        this.$message.error(error);
        return;
      }
      this.forwarder.forEach((item) => {
        if (item.intForwarderConfigId == this.form.intForwarderConfigId) {
          params.forwarderName = item.forwarder;
        }
      });
      if (params.weightCostConfigId) {
        editConfig(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success("成功");
            this.$emit("submitCallBack");
            this.dialogVisible = false;
          }
        });
        return false
      }
      addConfig(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit("submitCallBack");
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
